import { Breadcrumb, Button, Divider, Flex, Pagination, Table } from "antd";
import { Link } from "react-router-dom";
import { HomeOutlined, PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
import { useState } from 'react';
import GroupService from '../../services/collage'
import {useParams} from 'react-router-dom';

const columns = [
    {
        title: 'Коллаж',
        dataIndex: 'Name',   
        render: (text, record) => {
            console.log(record)
            let url = "/gallery/"+record.IdGallery+"/collage/" + record.Id
            return (<Link to={url ?? ""}>{text}</Link>)
        },
    }   
  ];

const Collages = () => {
    const params = useParams();

    const [idGallery, setIdGallery] = useState(0)
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(0)
    const [data, setData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([])

    const update = (galleryId) => {
        console.log("update")
        GroupService.list({
            id_gallery: galleryId,
            page: page
        })
        .then(response => {
            for (let i = 0; i < response.data.List.length; i++) {
                response.data.List[i].key = response.data.List[i].Id
                response.data.List[i].IdGallery = galleryId
            }

            setData(response.data.List)
            setTotal(response.data.Total)
        })
        .catch(e => {
        });
    }

    useEffect(() => {
        console.log("useEffect");
    
        // Преобразуем params.id в число (int)
        const idAsNumber = parseInt(params.id, 10);
    
        if (!isNaN(idAsNumber)) {
            setIdGallery(idAsNumber);  // Обновляем состояние с числовым значением
            console.log(idAsNumber);   // Логируем числовое значение
        } else {
            console.log("Invalid id");
        }
    
        // Обновляем данные с числовым id
        update(idAsNumber);
    
    }, [page]);    

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            let rows = [];
            for (let i = 0; i < selectedRows.length; i++) {
                rows.push(selectedRows[i].id)
            }

            setSelectedRows(rows)
        },
        getCheckboxProps: (record) => ({
          id: record.Id
        }),
    };    

    return (
        <>
            <div style={{paddingTop: '20px'}}>
                <Breadcrumb
                    separator=""
                    items={[
                    {
                        href: '/',
                        title: <HomeOutlined />,
                    },
                    {
                        type: 'separator',
                    },                    
                    {
                        href: '/galleries',
                        title: 'Галлереи',
                    },
                    {
                        type: 'separator',
                    },
                    {
                        href: `/gallery/${params.id}/collages`,
                        title: 'Коллажи',
                    }
                    ]}
                />
                </div>

            <Divider />

            <Flex gap="small" wrap="wrap">
            <Link to={`/gallery/${params.id}/collage`}>
                <Button type="primary" icon={<PlusCircleOutlined />} size='large' />
            </Link>
            <Button     
                type="primary" 
                icon={<DeleteOutlined />} 
                size='large' 
                onClick={(e) => {
                    GroupService.delete({
                        ids: selectedRows
                    })
                    .then(response => {
                        if (response.status == 200) {
                            update()
                        }
                    })
                    .catch(e => {
                    });
                }}
            />
            </Flex>

            <Divider />

            <Table 
                rowSelection={{
                    type: 'multiple',
                    ...rowSelection,
                }}
                dataSource={data}
                style={{overflow: 'scroll'}}
                bordered={true}
                pagination={false}
                columns={columns}
            />

            <div
                style={{
                    textAlign: 'right',
                    paddingTop: '20px',
                    paddingBottom: '20px'
                }}
            >
            <Pagination 
                hideOnSinglePage={true}
                defaultCurrent={1} 
                total={total} 
                defaultPageSize={8} 
                onChange={(page) => {
                    setPage(page-1)
                }}
                current={page+1}
            />
            </div>
        </>
    )
}

export default Collages;   